module.exports = __webpack_public_path__ + "img/cross-order.5d8fa210.svg";